import { ENVIRONMENTS } from "./environment.common"

export const ENVS = {
    ENVIRONMENT: ENVIRONMENTS.DEV
}